import { List, ListItem, Typography } from "@mui/material"
import Card from "components/Card/Card"
import IconButtonWithBorder from "components/StyledComponents/IconButtonWithBorder"
import React from "react"
import { useHistory } from "react-router-dom"
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos"
import { useDispatch, useSelector } from "react-redux"
import { DMVActions } from "redux/DMV/slice/user"

const ExploreMenuCard = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { menuCountry } = useSelector((state) => state?.dmv)

  return (
    <Card style={{ paddingBottom: 12 }}>
      <List>
        <ListItem sx={{ justifyContent: "space-between", padding: "0 0 16px 0" }}>
          <Typography variant="h2">Explore Menu</Typography>
          <span
            onClick={() => {
              history.push("/dmv/dashboard/explore-menu")
              const listItem = {
                item: "wine_region",
                category: menuCountry[0]?.id,
                name: menuCountry[0]?.name
              }
              dispatch(DMVActions?.setDMVMenuCategory(listItem))
            }}>
            <IconButtonWithBorder islight={true}>
              <ArrowForwardIosIcon
                sx={{
                  color: "white",
                  fontSize: "small"
                }}
              />
            </IconButtonWithBorder>
          </span>
        </ListItem>
      </List>
    </Card>
  )
}

export default ExploreMenuCard
